import { DomainBase } from "./DomainBase";

 export class TaxClass extends DomainBase {
    constructor() {
        super();
        this.name = "";
        this.percentage = 0;
    }
}